<template>
	<section class="main-content contentblocks-section">
		<slot name="extra-content" />
		<div
			v-for="(block, idx) in contentblocks"
			:key="block.ID"
			class="row block-item"
			:class="{ even: idx % 2 == 0 }"
		>
			<div class="columns column5">
				<div class="content-wrapper">
					<div class="content">
						<h3>{{ block.header }}</h3>
						<div v-parse-links v-html="block.content" />
					</div>
				</div>
			</div>
			<div class="columns column7">
				<picture>
					<source :srcset="block.imageWebp" type="image/webp" />
					<source :srcset="block.image" />
					<img :src="block.image" :alt="block.imageAlt" loading="lazy" />
				</picture>
			</div>
		</div>
	</section>
</template>

<script setup>
defineProps({
	contentblocks: { type: Array, default: () => [] },
});
</script>

<style lang="scss" scoped>
.contentblock-section {
	padding: 50px 0 100px;
}

.block-item {
	display: flex;
	justify-content: center;
	align-items: stretch;
	overflow: hidden;
	padding: 0 20px;
	margin: 0 auto;

	img {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}

	.column5 {
		background: $primary-background-color;
		padding: 10px;
	}

	.column7 {
		padding: 0;
	}

	.column5,
	.column7 {
		display: flex;
		justify-content: center;
		align-items: stretch;
	}

	.content {
		padding: 50px 75px;
		z-index: 2;
	}

	.content-wrapper {
		padding: 0;
		z-index: 2;
		display: flex;
		align-items: center;
		border: 2px solid #42737c;
	}
}

.block-item:nth-child(even) {
	flex-direction: row-reverse;
}

@media (max-width: 960px) {
	.block-item {
		margin: 20px auto;
	}

	.block-item,
	.block-item:nth-child(even) {
		flex-direction: column-reverse;

		.content-wrapper {
			padding: 0;
		}

		.content {
			margin-left: 0;
			margin-right: 0;
			padding: 50px;
		}
	}
}

@media (max-width: 600px) {
	.block-item,
	.block-item:nth-child(even) {
		.content {
			padding: 40px 30px 30px;
		}
	}
}
</style>
